(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('banner-slideshow')) {
    class BannerSlideshow extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.realCount = Number(this.dataset.count || 0);
        this.index = this.realCount > 1 ? 1 : 0;
        this.viewport = this.querySelector('.banner-slideshow__viewport');
        this.track = this.querySelector('.banner-slideshow__track');
        this.dragging = false;
        this.moved = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.viewport || !this.track || this.realCount < 2) return;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onClickCapture = this.onClickCapture.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        this.viewport.addEventListener('dragstart', (event) => event.preventDefault());
        this.viewport.addEventListener('click', this.onClickCapture, true);
        this.track.addEventListener('transitionend', this.onTransitionEnd);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        this.dots = [...this.querySelectorAll('.banner-slideshow__dot')];

        this.querySelectorAll('.banner-slideshow__arrow').forEach((button) => {
          button.addEventListener('click', () => {
            this.move(Number(button.dataset.direction));
          });
        });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const target = Number(dot.dataset.slide);
            if (!this.isSettled() || target === this.index) return;
            this.go(target);
          });
        });

        this.updateDots();

        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
        this.play();
      }

      disconnectedCallback() {
        this.pause();
        this.stopDrag();
      }

      stopDrag() {
        if (!this.onPointerMove) return;
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
      }

      isSettled() {
        return this.index >= 1 && this.index <= this.realCount;
      }

      play() {
        if (this.dataset.autoplay !== 'true' || this.timer) return;
        const speed = Number(this.dataset.speed || 5) * 1000;
        this.timer = window.setInterval(() => {
          if (!this.dragging) this.move(1);
        }, speed);
      }

      pause() {
        window.clearInterval(this.timer);
        this.timer = undefined;
      }

      move(step) {
        if (!this.isSettled()) return;
        this.go(this.index + step);
      }

      go(nextIndex) {
        this.track.style.transition = '';
        this.track.style.setProperty('--drag', '0px');
        this.track.classList.remove('is-instant');
        this.index = nextIndex;
        this.style.setProperty('--index', String(this.index));
        this.updateDots();
        if (this.reduceMotion) this.normalize();
      }

      updateDots() {
        if (!this.dots) return;
        let active = this.index;
        if (active <= 0) active = this.realCount;
        else if (active > this.realCount) active = 1;
        this.dots.forEach((dot, index) => {
          const selected = index + 1 === active;
          dot.classList.toggle('is-selected', selected);
          if (selected) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      normalize() {
        if (this.index >= 1 && this.index <= this.realCount) return;
        const target = this.index <= 0 ? this.realCount : 1;
        this.track.style.transition = 'none';
        this.index = target;
        this.style.setProperty('--index', String(target));
        this.track.offsetHeight;
        window.requestAnimationFrame(() => {
          this.track.style.transition = '';
        });
      }

      onTransitionEnd(event) {
        if (event.target !== this.track || event.propertyName !== 'transform') return;
        this.normalize();
      }

      onPointerDown(event) {
        if (!this.isSettled()) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.dragging = true;
        this.moved = false;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.viewport.classList.add('is-dragging');
        this.track.classList.add('is-dragging');
        window.addEventListener('pointermove', this.onPointerMove, { passive: false });
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        this.pause();
      }

      onPointerMove(event) {
        if (!this.dragging) return;
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        if (Math.abs(dx) > Math.abs(dy)) event.preventDefault();
        if (Math.abs(dx) > 8) this.moved = true;
        this.track.style.setProperty('--drag', `${dx}px`);
      }

      onPointerUp() {
        if (!this.dragging) return;
        const dragValue = this.track.style.getPropertyValue('--drag');
        const dx = Number.parseFloat(dragValue) || 0;
        this.dragging = false;
        this.stopDrag();
        this.viewport.classList.remove('is-dragging');

        const threshold = this.viewport.clientWidth * 0.12;
        let target = this.index;
        if (dx <= -threshold) target += 1;
        else if (dx >= threshold) target -= 1;

        this.track.classList.remove('is-dragging');
        this.track.offsetHeight;
        this.go(target);
        window.setTimeout(() => {
          this.moved = false;
        }, 0);
        this.play();
      }

      onClickCapture(event) {
        if (this.moved) {
          event.preventDefault();
          event.stopPropagation();
          this.moved = false;
          return;
        }

        const target = event.target instanceof Element ? event.target : null;
        if (target?.closest('a.banner-slideshow__media')) return;

        const point = document.elementFromPoint(event.clientX, event.clientY);
        const link = point?.closest?.('a.banner-slideshow__media')
          || point?.closest?.('.banner-slideshow__slide')?.querySelector('a.banner-slideshow__media')
          || target?.closest('.banner-slideshow__slide')?.querySelector('a.banner-slideshow__media');
        if (!link?.href) return;

        window.location.href = link.href;
      }

      onBlockSelect(event) {
        const slide = event.target.closest('.banner-slideshow__slide');
        if (!slide || slide.classList.contains('is-clone') || !this.track) return;
        const slides = [...this.querySelectorAll('.banner-slideshow__slide:not(.is-clone)')];
        const position = slides.indexOf(slide);
        if (position < 0) return;
        this.track.classList.add('is-instant');
        this.index = position + 1;
        this.style.setProperty('--index', String(this.index));
        this.updateDots();
      }
    }

    customElements.define('banner-slideshow', BannerSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindKlaviyoTriggers(root) {
      (root || document).querySelectorAll('.klaviyo_form_trigger').forEach(function (button) {
        if (button.dataset.klaviyoBound === 'true') return;
        button.dataset.klaviyoBound = 'true';
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var formId = button.getAttribute('data-klaviyo-form');
          if (!formId) return;
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', formId]);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        bindKlaviyoTriggers();
      });
    } else {
      bindKlaviyoTriggers();
    }

    document.addEventListener('shopify:section:load', function (event) {
      bindKlaviyoTriggers(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.announcement = document.querySelector('.top-marquee-section');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      window.addEventListener('resize', this.onResizeHandler);

      if (this.announcement && typeof ResizeObserver !== 'undefined') {
        this.announcementObserver = new ResizeObserver(this.onResizeHandler);
        this.announcementObserver.observe(this.announcement);
      }

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      const announcementHeight = this.announcement ? this.announcement.offsetHeight : 0;
      document.documentElement.style.setProperty('--header-sticky-offset', `${announcementHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      if (this.announcementObserver) this.announcementObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
